import { render, staticRenderFns } from "./UnvocalizedScan.vue?vue&type=template&id=84d0c61a"
import script from "./UnvocalizedScan.vue?vue&type=script&lang=js"
export * from "./UnvocalizedScan.vue?vue&type=script&lang=js"
import style0 from "./UnvocalizedScan.vue?vue&type=style&index=0&id=84d0c61a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports